import { put, takeEvery } from "redux-saga/effects"
import {
  addCommunicationFailed,
  addCommunicationSuccess,
  deleteCommunicationFailed,
  deleteCommunicationSuccess,
  getCommunicationFailed,
  getCommunicationSuccess,
  getCustomEmailsFailed,
  getCustomEmailsSuccess,
  getEventsBySearchFailed,
  getEventsBySearchSuccess,
  getNotificationsFailed,
  getNotificationsSuccess,
  getUsersFailed,
  getUsersSuccess,
  getWebAlertsFailed,
  getWebAlertsSuccess,
  hideDeleteCommunicationModal,
  hideSendCommunicationModal,
  hideSendWebAlertModal,
  sendCommunicationFailed,
  sendCommunicationSuccess,
  sendWebAlertFailed,
  sendWebAlertSuccess,
  updateCommunicationFailed,
} from "./actions"
import { showToast } from "../../utils"
import { axiosPut, del, get, post } from "helpers/api_helper"
import * as url from "helpers/url_helper"
import {
  ADD_COMMUNICATION,
  DELETE_COMMUNICATION,
  GET_COMMUNICATION,
  GET_CUSTOM_EMAILS,
  GET_EVENTS_BY_SEARCH,
  GET_USERS,
  GET_NOTIFICATIONS,
  GET_WEB_ALERTS,
  SEND_COMMUNICATION,
  SEND_WEB_ALERT,
  UPDATE_COMMUNICATION,
} from "./actionTypes"
import { URL_PATHS } from "constants/index"

function* getNotifications({ payload: params }) {
  try {
    const response = yield get(url.COMMUNICATIONS_URL, { params })
    yield put(getNotificationsSuccess(response))
  } catch (error) {
    yield put(getNotificationsFailed(error))
    showToast("error", error, "Error")
  }
}

function* getCustomEmails({ payload: params }) {
  try {
    const response = yield get(url.COMMUNICATIONS_URL, { params })
    yield put(getCustomEmailsSuccess(response))
  } catch (error) {
    yield put(getCustomEmailsFailed(error))
    showToast("error", error, "Error")
  }
}

function* getWebAlerts({ payload: params }) {
  try {
    const response = yield get(url.WEB_ALERTS_URL, { params })
    yield put(getWebAlertsSuccess(response))
  } catch (error) {
    yield put(getWebAlertsFailed(error))
    showToast("error", error, "Error")
  }
}

function* getEventsBySearch({ payload: params }) {
  try {
    const response = yield get("/admin/search/events", { params })
    yield put(getEventsBySearchSuccess(response))
  } catch (error) {
    yield put(getEventsBySearchFailed(error))
    showToast("error", error, "Error")
  }
}

function* addCommunication({ payload: params }) {
  try {
    yield post(url.COMMUNICATIONS_URL, params.values)
    yield put(addCommunicationSuccess())
    params.history.push(URL_PATHS.COMMUNICATIONS)
    showToast("success", "Communication created!", "Success")
  } catch (error) {
    yield put(addCommunicationFailed(error))
    showToast("error", error, "Error")
  }
}

function* deleteCommunication({ payload: { callback, ...params } }) {
  try {
    yield del(`${url.COMMUNICATIONS_URL}/${params.id}`)
    yield put(deleteCommunicationSuccess())
    yield put(hideDeleteCommunicationModal())
    if (callback) {
      callback()
    }
    showToast("success", "Communication deleted!", "Success")
  } catch (error) {
    yield put(deleteCommunicationFailed(error))
    showToast("error", error, "Error")
  }
}

function* getCommunication({ payload: params }) {
  try {
    const response = yield get(`${url.COMMUNICATIONS_URL}/${params}`)
    yield put(getCommunicationSuccess(response))
  } catch (error) {
    yield put(getCommunicationFailed(error))
    showToast("error", error, "Error")
  }
}

function* updateCommunication({ payload: params }) {
  try {
    yield axiosPut(
      `${url.COMMUNICATIONS_URL}/${params.values.id}`,
      params.values
    )
    params.history.push(URL_PATHS.COMMUNICATIONS)
    showToast("success", "Communication updated!", "Success")
  } catch (error) {
    yield put(updateCommunicationFailed(error))
    showToast("error", error, "Error")
  }
}

function* sendCommunication({ payload: { callback, ...params } }) {
  try {
    yield post(`${url.COMMUNICATIONS_URL}/send`, params)
    yield put(sendCommunicationSuccess())
    yield put(hideSendCommunicationModal())
    if (callback) {
      callback()
    }
    showToast("success", "Communication sent!", "Success")
  } catch (error) {
    yield put(sendCommunicationFailed(error))
    showToast("error", error, "Error")
  }
}

function* sendWebAlert({ payload: { callback, ...params } }) {
  try {
    yield post(url.WEB_ALERTS_URL, params)
    yield put(sendWebAlertSuccess())
    yield put(hideSendWebAlertModal())
    if (callback) {
      yield put(callback())
    }
    showToast("success", "Alert sent!", "Success")
  } catch (error) {
    yield put(sendWebAlertFailed(error))
    showToast("error", error, "Error")
  }
}

function* getIndividualUsers({ payload: params }) {
  try {
    const response = yield post(url.GET_USERS, params)
    yield put(getUsersSuccess(response))
  } catch (error) {
    yield put(getUsersFailed(error))
    showToast("error", error, "Error")
  }
}

function* communicationsSaga() {
  yield takeEvery(GET_NOTIFICATIONS, getNotifications)
  yield takeEvery(GET_CUSTOM_EMAILS, getCustomEmails)
  yield takeEvery(GET_WEB_ALERTS, getWebAlerts)
  yield takeEvery(GET_EVENTS_BY_SEARCH, getEventsBySearch)
  yield takeEvery(ADD_COMMUNICATION, addCommunication)
  yield takeEvery(DELETE_COMMUNICATION, deleteCommunication)
  yield takeEvery(GET_COMMUNICATION, getCommunication)
  yield takeEvery(UPDATE_COMMUNICATION, updateCommunication)
  yield takeEvery(SEND_COMMUNICATION, sendCommunication)
  yield takeEvery(SEND_WEB_ALERT, sendWebAlert)
  yield takeEvery(GET_USERS, getIndividualUsers)
}

export default communicationsSaga
